import { Component, OnInit, Input, OnChanges, SimpleChanges, forwardRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { Placeholder } from '@angular/compiler/src/i18n/i18n_ast';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'alg-select',
  templateUrl: './alg-select.component.html',
  styleUrls: ['./alg-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting:forwardRef(() => AlgSelectComponent),
    multi: true,
  }]
})
export class AlgSelectComponent implements OnInit, ControlValueAccessor{

  @ViewChild('ngSelect') private ngSelect : NgSelectComponent; 

  @Input() placeholder: string;
  @Input() label: string;
  @Input() labelSecond: string;
  @Input() labelThree: string;
  @Input() name: string;
  @Input() type: any;
  @Input() errorMessage: string;
  @Input() typeahead: any;
  @Input() addTag = false;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() blur: EventEmitter<any> = new EventEmitter<any>();
  @Input() items: any[];
  @Input() id: string;

  @Input()
  set selectedValue(selectedValue: string) {         
    if(selectedValue){
      setTimeout(() => {      
        this.ngSelect.blurEvent.emit()
      }, 1500);    
    }      
    this._selectedValue = (selectedValue && selectedValue.trim()) || undefined;
  }
  
  @Output("openInfo") help: EventEmitter<any> = new EventEmitter<any>();

  get selectedValue(): string { return this._selectedValue; }

  private _selectedValue = undefined;
  public idSelect: string;
  public isOpen = false;
  public value: string = '';
  public filteredItems: any[];
  private propagateChange = (_: any) => { };
  private propagateTouch = () => { };

  constructor() { }

  ngOnInit() {    
    this.idSelect = `select-${this.name}`;
    this.filteredItems = this.items || [];   
  }

  ngOnChanges(changes: SimpleChanges){           
    if(changes.selectedValue && changes.selectedValue.currentValue){                        
       
    }     
    if (changes.name) {
      this.idSelect = `select-${changes.name.currentValue}`;
    } if (changes.items) {
      this.filteredItems = changes.items.currentValue;
    }
  }

  onChange(selectedItem){
    this.value = selectedItem.value;
    this.propagateChange(this.value);
    this.change.emit({target: {value: selectedItem.value}});
    this.isOpen = false;
  }

  onBlur(event){
    this.propagateTouch();
    this.blur.emit(event);
  }

  public writeValue(obj: any) {
    if(obj){
      this.value = obj;
    }
  }

  public registerOnChange(fn: any) {
     this.propagateChange = fn;
  }
  public registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  public isOpenToggle() {
    this.isOpen = !this.isOpen;
    const self = this;
  }

  onClick(){
    this.help.emit()
  }

}



// WEBPACK FOOTER //
// ./src/app/components/atoms/alg-select/alg-select.component.ts